import { useForm } from 'react-hook-form';
import Input from '../../../components/Input/Input';
import { validationSchema } from '../validations/code.validation';
import { yupResolver } from '@hookform/resolvers/yup';
import ErrorText from '../../../components/ErrorText';
import { useEffect, useState } from 'react';
import { useLoginWithEmail } from '@privy-io/react-auth';

interface FormInputs {
  code: string;
}

const CodeInput = () => {
  const { loginWithCode } = useLoginWithEmail();
  const [authError, setAuthError] = useState<string>('');

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<FormInputs>({
    resolver: yupResolver(validationSchema),
    mode: 'onBlur',
  });

  const onSubmit = async ({ code }: FormInputs) => {
    try {
      setAuthError('');
      await loginWithCode({ code: code.toString() });
    } catch (error) {
      console.log(error);
      setAuthError('Invalid Code');
    }
  };
  const code = watch('code');

  useEffect(() => {
    (async () => {
      if (code && code.length === 6) {
        handleSubmit(onSubmit)();
      }
    })();
  }, [code]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <Input
          type="text"
          placeholder="Enter Code"
          {...register('code')}
          fullWidth
          error={!!errors.code}
          autoComplete="off"
        />
        {errors.code?.message && <ErrorText>* {errors.code.message}</ErrorText>}
      </div>

      {authError && <ErrorText>{authError}</ErrorText>}
    </form>
  );
};

export default CodeInput;
